import React, { useCallback, useState } from "react";
// COMPONENTS
import SitePageShell from "Components/WebsiteTheme/SitePageShell";
import SiteCtaBand from "Components/WebsiteTheme/SiteCtaBand";
import SiteTestimonial from "Components/WebsiteTheme/SiteTestimonial";
import SiteVideoModal from "Components/WebsiteTheme/SiteVideoModal";
import HeroBanner from "./HeroBanner";
import HowItWorks from "./HowItWorks";
import PilotBand from "./PilotBand";
import HomeSubjects from "./HomeSubjects";
import ClassroomShowcase from "./ClassroomShowcase";
import SubscriptionPlansSection from "./SubscriptionPlansSection";
// VIDEO
import HomePageIntroVideo from "Assets/Sounds/HomePageIntro.mp4";

/**
 * Website home page (Oct 2026 reference design). Shares its header, footer, testimonial, closing band,
 * pillars, subjects and wording with the About page through Components/WebsiteTheme.
 */
const LandingPage = () => {
	const [videoOpen, setVideoOpen] = useState(false);
	const openVideo = useCallback(() => setVideoOpen(true), []);
	const closeVideo = useCallback(() => setVideoOpen(false), []);

	return (
		<SitePageShell className="home_landing-wrapper">
			<HeroBanner />
			<HowItWorks onWatchVideo={openVideo} />
			<PilotBand />
			<SiteTestimonial className="st_after_band" />
			<HomeSubjects />
			<ClassroomShowcase />
			<SubscriptionPlansSection />
			<SiteCtaBand title="Ready to Transform Study Time into Game Time?" text="See what happens when the material you’re already teaching becomes an interactive learning experience." />

			<SiteVideoModal open={videoOpen} onClose={closeVideo} src={HomePageIntroVideo} title="Subjects Master introduction video" />
		</SitePageShell>
	);
};

export default LandingPage;
